export enum RekensprintRouterEnum {
  Practice = 'practice',
  KitchenSink = 'kitchensink',
  Test = 'test',
  TaskResult = 'task-result',
  UserActivity = 'user-activity',
}
